var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"scroll-wrapper"},[_c('section',{staticClass:"hero-sticky-wrapper"},[_c('Hero'),_c('BookingsViewVue'),_c('HomeMaintenancePackages'),_c('Services')],1),_c('div',{staticClass:"scroll-content"},[_c('Testimonials'),_c('FaqSection'),_c('Contact')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }